import Grid from '@mui/material/Unstable_Grid2/Grid2'
import { Button, Typography } from '@mui/material'
import React, { useState, useEffect, useRef } from 'react'

const AudioOne = ({ src, title }) => {
    const [isPlaying, setIsPlaying] = useState(false) // estado para controlar se o áudio está tocando ou não
    const audioRef = useRef() // referência ao elemento de áudio
    const progressBarRef = useRef() // referência à barra de progresso do áudio
    const [timeProgress, setTimeProgress] = useState(0) // estado para controlar o progresso do áudio
    const [duration, setDuration] = useState(0) // estado para controlar a duração do áudio

    // função para formatar o tempo do áudio
    const formatTime = (time) => {
        if (time && !isNaN(time)) {
            const minutes = Math.floor(time / 60)
            const formatMinutes =
            minutes < 10 ? `0${minutes}` : `${minutes}`
            const seconds = Math.floor(time % 60)
            const formatSeconds =
            seconds < 10 ? `0${seconds}` : `${seconds}`
            return `${formatMinutes}:${formatSeconds}`
        }
        return '00:00'
    }

    const onLoadedMetadata = () => {
        const seconds = audioRef.current.duration
        setDuration(seconds)
        progressBarRef.current.max = seconds
    }

    // função para tocar o áudio
    const playAudio = () => {
        audioRef.current.play()
        setIsPlaying(true)
    }

    // função para pausar o áudio
    const pauseAudio = () => {
        audioRef.current.pause()
        setIsPlaying(false)
    }

    // função para alternar entre tocar e pausar o áudio
    const togglePlayPause = () => {
        isPlaying ? pauseAudio() : playAudio()
    }

    // função para avançar 10 segundos no áudio
    const fastForwardAudio = () => {
        audioRef.current.currentTime += 10
    }

    // função para retroceder 10 segundos no áudio
    const rewindAudio = () => {
        audioRef.current.currentTime -= 10
    }

    // hook useEffect para adicionar e remover event listeners ao elemento de áudio
    useEffect(() => {
    // função para atualizar o estado de reprodução quando o áudio termina
        const updateIsPlaying = () => {
            setIsPlaying(false)
        }

        // adiciona o event listener ao elemento de áudio
        audioRef.current.addEventListener('ended', updateIsPlaying)

        // remove o event listener quando o componente é desmontado
        return () => {
            // audioRef.current.removeEventListener('ended', updateIsPlaying)
        }
    }, [])

    useEffect(() => {
        const updateProgress = () => {
            setTimeProgress(audioRef.current.currentTime)
        }

        audioRef.current.addEventListener('timeupdate', updateProgress)

        return () => {
            // audioRef.current.removeEventListener('timeupdate', updateProgress)
        }
    }, [])

    return (
        <Grid contianer
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                width: '500px',
                height: '100%'
            }}
        >
            <Grid container
                sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-evenly',
                    alignItems: 'center'
                }}>
                <Typography fontWeight="600">{formatTime(timeProgress)}</Typography>
                {/* <LinearProgress
                    sx={{ width: '300px', height: '10px', backgroundColor: '#e0e0e0', border: '1px solid black' }}
                    variant="determinate"
                    color='secondary'
                    value={(timeProgress / duration) * 100}
                /> */}
                <input
                    type="range"
                    value={timeProgress}
                    max={duration}
                    style={{
                        width: '300px',
                        height: '20px'
                    }}
                />
                <Typography fontWeight="600">{formatTime(duration)}</Typography>
            </Grid>
            <audio src={src} ref={audioRef} onLoadedMetadata={onLoadedMetadata} />
            <Grid sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-evenly',
                alignItems: 'center',
                width: '100%',
                padding: '10px'
            }}>
                <Button
                    variant="contained"
                    color="one_primary"
                    sx={{ height: { lg: '20px', xl: '30px' }, fontSize: { lg: '11px', xl: '14px' } }}
                    onClick={rewindAudio}
                >
                    -10s</Button>
                <Button
                    variant="contained"
                    color="one_primary"
                    sx={{ height: { lg: '20px', xl: '30px' }, fontSize: { lg: '11px', xl: '14px' } }}
                    onClick={togglePlayPause}>
                    {isPlaying ? 'Pausar' : 'Tocar'}
                </Button>
                <Button
                    variant="contained"
                    color="one_primary"
                    sx={{ height: { lg: '20px', xl: '30px' }, fontSize: { lg: '11px', xl: '14px' } }}
                    onClick={fastForwardAudio}>
                        +10s
                </Button>
            </Grid>
        </Grid>
    )
}

export default AudioOne
